
export const text = `

Remember, this does not apply to you if you leave Youtube looping in the background to listen to music. Just don't check the videos too frequently. Or listen to them. Do not remember them. If at any point you feel like running, don't. 
`